<template>
  <div class="LogoStripCentered" :class="mode">
    <div v-if="content.caption" class="caption">{{ content.caption }}</div>
    <div v-if="content.logos" class="logos">
      <div v-for="{ _key, logo, title } in content.logos" :key="_key" class="logo">
        <SanityImage v-if="logo" :asset="logo.asset" :alt="title" class="logoImage" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: Object,
    mode: String,
  },
}
</script>

<style scoped>

.caption {
  font-weight: 400;
  font-size: var(--font-size-1);
  line-height: 1.3;
  text-align: center;
}

.LogoStripCentered .caption {
  color: #9C9C9C;
}

.LogoStripCentered.dark .caption {
  color: white;
}

.logos {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  column-gap: var(--spacing-13);
  row-gap: var(--spacing-6);
  max-width: 100%;
}

.logo {
  flex-shrink: 0;
}

.logoImage {
  height: var(--logo-height-mobile, 30px);
}

.LogoStripCentered.dark .logoImage {
  filter: brightness(0) invert();
}

.caption + .logos {
  margin-top: var(--spacing-5);
}

@media (--screen-lg) {
  .logoImage {
    height: var(--logo-height, 50px);
  }
}
</style>
